// extracted by mini-css-extract-plugin
module.exports = {"message":"Show_message__30onr"};